module.exports = __webpack_public_path__ + "img/phone.a4af5ae0.png";